import { render } from "./DialogCloseBtn.vue?vue&type=template&id=7cd3f024&scoped=true&lang=pug"
import script from "./DialogCloseBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCloseBtn.vue?vue&type=script&setup=true&lang=js"

import "./DialogCloseBtn.vue?vue&type=style&index=0&id=7cd3f024&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd3f024"]])

export default __exports__